import Vue from "vue";
import Router from "vue-router";
import login from "@/components/login";
import asmt_index from "@/components/asmt/index";
import asmt_record from "@/components/asmt/asmt_record";
import asmt_scale_flow from "@/components/asmt/asmt_scale_flow";

import cust_index from "@/components/cust/index";

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/login",
            name: "login",
            component: login
        },
        {
            path: "/asmt/index",
            name: "asmt_index",
            component: asmt_index
        },
        {
            path: "/asmt/asmt_record",
            name: "asmt_record",
            component: asmt_record
        },
        {
            path: "/asmt/asmt_scale_flow",
            name: "asmt_scale_flow",
            component: asmt_scale_flow
        },
        {
            path: "/asmt/asmt_scale_paper_survey",
            name: "asmt_scale_paper_survey",
            component: ()=>import('@/components/asmt/asmt_scale_paper_survey')
        },
        {
            path: "/asmt/asmt_confirm_paper",
            name: "asmt_confirm_paper",
            component: ()=>import('@/components/asmt/asmt_confirm_paper')
        },

        {
            path: "/cust/index",
            name: "cust_index",
            component: cust_index
        },
        {
            path: "/cust/tab_mine",
            name: "cust_tab_mine",
            component: ()=>import('@/components/cust/tab_mine')
        },
        {
            path: "/cust/asmt/bind_cust",
            name: "cust_asmt_bind_cust",
            component: ()=>import('@/components/cust/asmt/bind_cust')
        },
        {
            path: "/cust/asmt/cust_asmt_record",
            name: "cust_asmt_cust_asmt_record",
            component: ()=>import('@/components/cust/asmt/cust_asmt_record')
        },
        {
            path: "/cust/asmt/cust_asmt_record_detail",
            name: "cust_asmt_cust_asmt_record_detail",
            component: ()=>import('@/components/cust/asmt/cust_asmt_record_detail')
        },
        {
            path: "/cust/visit/warn_visit",
            name: "cust_visit_warn_visit",
            component: ()=>import('@/components/cust/visit/warn_visit')
        },
        {
            path: "/cust/visit/asmt_record_detail",
            name: "cust_visit_asmt_record_detail",
            component: ()=>import('@/components/cust/visit/asmt_record_detail')
        },
        {
            path: "/cust/visit/asmt_visit_record_unover",
            name: "cust_visit_asmt_visit_record_unover",
            component: ()=>import('@/components/cust/visit/asmt_visit_record_unover')
        },
        {
            path: "/cust/visit/asmt_visit_record_form",
            name: "cust_visit_asmt_visit_record_form",
            component: ()=>import('@/components/cust/visit/asmt_visit_record_form')
        },
        {
            path: "/cust/mine/statement",
            name: "cust_mine_statement",
            component: ()=>import('@/components/cust/mine/statement')
        },
        {
            path: "/cust/mine/notice",
            name: "cust_mine_notice",
            component: ()=>import('@/components/cust/mine/notice')
        },
        {
            path: "/cust/mine/notice_detail",
            name: "cust_mine_notice_detail",
            component: ()=>import('@/components/cust/mine/notice_detail')
        },
        {
            path: "/cust/mine/settings_sys",
            name: "cust_mine_settings_sys",
            component: ()=>import('@/components/cust/mine/settings_sys')
        },
        {
            path: "/cust/mine/settings_crm",
            name: "cust_mine_settings_crm",
            component: ()=>import('@/components/cust/mine/settings_crm')
        },

        {
            path: "/cust/spt/ihys_guest_portal",
            name: "cust_spt_ihys_guest_portal",
            component: ()=>import('@/components/cust/spt/ihys_guest_portal')
        },
        {
            path: "/cust/spt/ihys_guest_chat",
            name: "cust_spt_ihys_guest_chat",
            component: ()=>import('@/components/cust/spt/ihys_guest_chat')
        },
        {
            path: "/cust/spt/spt_portal",
            name: "cust_spt_spt_portal",
            component: ()=>import('@/components/cust/spt/spt_portal')
        },
        {
            path: "/cust/spt/ihys_host_portal",
            name: "cust_spt_ihys_host_portal",
            component: ()=>import('@/components/cust/spt/ihys_host_portal')
        },
        {
            path: "/cust/spt/ihys_host_chat",
            name: "cust_spt_ihys_host_chat",
            component: ()=>import('@/components/cust/spt/ihys_host_chat')
        },
        {
            path: "/cust/spt/bbs_portal",
            name: "cust_spt_bbs_portal",
            component: ()=>import('@/components/cust/spt/bbs_portal')
        },
        {
            path: "/cust/spt/bbs_view",
            name: "cust_spt_bbs_view",
            component: ()=>import('@/components/cust/spt/bbs_view')
        },

        {
            path: "/mod/resource_portal",
            name: "mod_resource_portal",
            component: ()=>import('@/components/mod/resource_portal')
        },
        {
            path: "/mod/resource_detail",
            name: "mod_resource_detail",
            component: ()=>import('@/components/mod/resource_detail')
        },

        {
            path: "/cust/spt/ai_chat",
            name: "cust_spt_ai_chat",
            component: ()=>import('@/components/cust/spt/ai_chat')
        },
        {
            path: "/cust/spt/mood_portal",
            name: "cust_spt_mood_portal",
            component: ()=>import('@/components/cust/spt/mood_portal')
        },
        {
            path: "/cust/spt/mood_recorder",
            name: "cust_spt_mood_recorder",
            component: ()=>import('@/components/cust/spt/mood_recorder')
        },

        {
            path: "/cust/spt/activity_portal",
            name: "cust_spt_activity_portal",
            component: ()=>import('@/components/cust/spt/activity_portal')
        },
        {
            path: "/cust/spt/activity_detail",
            name: "cust_spt_activity_detail",
            component: ()=>import('@/components/cust/spt/activity_detail')
        },

        
        {
            path: "/cust/spt/consult_host_portal",
            name: "cust_spt_consult_host_portal",
            component: ()=>import('@/components/cust/spt/consult_host_portal')
        },
        {
            path: "/cust/spt/consult_guest_portal",
            name: "cust_spt_consult_guest_portal",
            component: ()=>import('@/components/cust/spt/consult_guest_portal')
        },
        {
            path: "/cust/spt/consult_guest_order",
            name: "cust_spt_consult_guest_order",
            component: ()=>import('@/components/cust/spt/consult_guest_order')
        },
        {
            path: "/cust/spt/consult_guest_times",
            name: "cust_spt_consult_guest_times",
            component: ()=>import('@/components/cust/spt/consult_guest_times')
        },
        {
            path: "/cust/spt/consult_guest_chat",
            name: "cust_spt_consult_guest_chat",
            component: ()=>import('@/components/cust/spt/consult_guest_chat')
        },
        {
            path: "/cust/spt/consult_host_chat",
            name: "cust_spt_consult_host_chat",
            component: ()=>import('@/components/cust/spt/consult_host_chat')
        },
        {
            path: "/cust/spt/consult_host_order",
            name: "cust_spt_consult_host_order",
            component: ()=>import('@/components/cust/spt/consult_host_order')
        },
        
        {
            path: "/cust/asmt/crm_feedback",
            name: "cust_asmt_crm_feedback",
            component: ()=>import('@/components/cust/asmt/crm_feedback')
        },
        
        {
            path: "/cust/spt/external/consult_sn_2607",
            name: "cust_spt_consult_sn_2607",
            component: ()=>import('@/components/cust/spt/external/consult_sn_2607')
        },

        // { path: '/activiti/process', component: _import('@/components/activiti/process'), name: 'activiti-process', meta: { title: '流程', isTab: true } },
        // { path: '/activiti/detail/:id', component: _import('@/components/activiti/detail'), name: 'activiti-detail', meta: { title: 'detail' } },
        // { path: '/activiti/task', component: _import('@/components/activiti/task'), name: 'activiti-task', meta: { title: '任务', isTab: true } }
    ]
});

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const whiteList = {
    "/cust/spt/activity_detail": true,
    "/asmt/asmt_confirm_paper": true,
    "/cust/spt/external/consult_sn_2607": true,
};

router.beforeEach((to, from, next) => {
    // console.log(to.path);
    // console.log(to);
    // console.log(from);
    // console.log(next);

    // 回话管理模式待定，优先使用session，其次考虑拦截器自己实现，不考虑shiro
    const token = sessionStorage.getItem("hwt-token");
    if (to.path === "/login") {
        if (token !== "null" && token !== null) {
            const type = sessionStorage.getItem("type");
            if (type == 21) {
                next("/asmt/index");
            } else if (type == 31) {
                next("/cust/index");
            }
        }
        next();
    } else if (whiteList[to.path]) {
        next();
    } else {
        if (token !== "null" && token !== null) {
            // 待验证作用
            next();
        } else {
            next("/login");
        }
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js